import { TEDCustomDateTimeParser } from './TEDCustomDateTimeParser';
import { TEDParseDateTimeMode } from '../FormatterTypes';

export class TEDParseDateTime extends TEDCustomDateTimeParser {
  public static getInstance(): TEDParseDateTime {
    return this.instance ? this.instance : (this.instance = new this());
  }

  private static instance: TEDParseDateTime;

  public mode() {
    return TEDParseDateTimeMode.pdmYMDHM;
  }
}
